<template>
  <v-container>
    <!-- <v-row justify-md="space-between">
      <v-col cols="12" md="auto">
        <v-btn
          @click="openFormDialog"
          class="accent shadow-4 px-8"
          color="success"
          large
          rounded
        >
          Añadir Tarificador
        </v-btn>
      </v-col>
    </v-row> -->

    <!-- show-expand
        single-expand -->
    <br />

    <v-card class="shadow-1 mt-5">
      <v-data-table
        :search="search"
        :headers="headers"
        :items="surveysList"
        item-key="id"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100],
        }"
      >
        <template v-slot:[`item.start`]="{ item }">
          <span>{{ item.start | dateFormat }}</span>
        </template>

        <template v-slot:[`item.end`]="{ item }">
          <span>{{ item.end | dateFormat }}</span>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleShow(item.id)"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleComplete(item.id)"
            >
              <v-icon>mdi-file-document-plus-outline</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              text
              icon
              :color="hover ? 'accent' : 'blue-grey'"
              @click.stop="handleInfo(item.id)"
            >
              <v-icon>mdi-information</v-icon>
            </v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }" v-if="item.question_count == 0">
            <v-btn
              text
              icon
              :color="hover ? 'error' : 'blue-grey'"
              @click.stop="handleDelete(item)"
            >
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </v-hover>
        </template>
      </v-data-table>
    </v-card>

    <userDialog
      v-if="isOpenForm"
      :isActive="isOpenForm"
      :surveyID="surveyIDSelected"
      :isEditMode="isEditMode"
      @close:dialog="closeFormDialog"
    ></userDialog>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
// import newForm from "./newForm.vue";
import userDialog from "@/views/app/formBuilder/userDialog";

export default {
  components: {
    // newForm,
    userDialog,
  },

  data: () => ({
    isLoading: false,
    isOpenForm: false,
    isEditMode: false,
    surveyIDSelected: null,
    // For pagination
    totalItems: 0,
    options: {
      page: 1,
      itemsPerPage: 15,
    },
    // End for pagination
    surveysList: [],
    eventToEdit: {},
    search: "",
    headers: [
      {
        text: "Formulario",
        align: "left",
        value: "name",
        class: "primary--text",
        width: "20%",
      },
      {
        text: "Inicio",
        value: "start",
        class: "primary--text",
        width: "15%",
      },
      {
        text: "Fin",
        value: "end",
        class: "primary--text",
        width: "15%",
      },
      // {
      //   text: "Creado",
      //   align: "left",
      //   value: "created_at",
      //   class: "primary--text",
      //   width: "15%",
      // },
      {
        text: "Acciones",
        value: "action",
        class: "primary--text",
        width: "15%",
        align: "left",
        sortable: false,
      },
    ],
  }),

  watch: {
    options: {
      handler() {
        this.getSurveys();
      },
      deep: true,
    },
  },

  created() {
    this.getSurveys();
  },

  methods: {
    closeFormDialog() {
      this.isOpenForm = false;
    },

    handleShow(SurveyId) {
      this.$router.push({
        name: "Detalles de formulario",
        params: { SurveyId },
      });
    },

    handleComplete(SurveyId) {
      this.surveyIDSelected = SurveyId;
      this.isOpenForm = true;
      // this.$router.push({
      //   name: "Completar formulario",
      //   params: { SurveyId },
      // });
    },

    handleInfo(SurveyId) {
      this.$router.push({
        name: "Resultados formularios",
        params: { SurveyId },
      });
    },

    // handleEdit(item) {
    //   this.isEditMode = true;
    //   this.eventToEdit = item;
    //   this.openFormDialog();
    // },

    async handleDelete(event) {
      try {
        const confirmRequest = await this.$swalconfirm(
          "Confirmar",
          `Está seguro de eliminar este evento? Ésta acción no es reversible.`
        );
        if (confirmRequest.isConfirmed) {
          PbxHttpClient.delete(`/surveys/survey/${event.id}`)
            .then((res) => {
              const index = this.surveysList.findIndex(
                (el) => el.id === res.data.Troncal
              );
              this.surveysList.splice(index, 1);

              this.$snotify.success("Encuesta eliminada", "¡Hecho!");
            })
            .catch((error) => {
              // console.error(error);
              this.$snotify.error("Hubo un error al eliminar.", "Error");
            });
        }
      } catch (error) {
        this.$snotify.error("No se pudo eliminar la encuesta.", "¡Error!");
        // console.error(error);
      }
    },

    // closeFormDialog(data = false) {
    //   if (data && this.isEditMode)
    //     this.surveysList = this.surveysList.map((el) =>
    //       el.id === data.id ? data : el
    //     );
    //   if (data && !this.isEditMode)
    //     this.surveysList = [...this.surveysList, data];
    //   this.isOpenForm = false;
    //   this.isEditMode = false;
    //   this.eventToEdit = {};
    // },

    async getSurveys() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/surveys/survey`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.surveysList = res.data.data;
          this.totalItems = res.data.total;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
